export default "__VITE_ASSET__cwCSyKrD__"